import API_ENDPOINTS from "app/config/endpoints";
import axios from "axios";
const tenantId = process.env.REACT_APP_TENANT_ID;

// Create a base axios instance with tenantId header
export const baseAxios = axios.create({});

baseAxios.interceptors.request.use(
  (config) => {
    if (tenantId) {
      config.headers["Tenantid"] = tenantId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth and school axios instances extend baseAxios
export const authTokenAxios = axios.create();
export const schoolTokenAxios = axios.create();

// Always get latest tokens from localStorage in request interceptors

authTokenAxios.interceptors.request.use(
  (config) => {
    const authAccessToken = localStorage.getItem("authAccessToken");
    if (authAccessToken) {
      config.headers["Authorization"] = `Bearer ${authAccessToken}`;
    }
    if (tenantId) {
      config.headers["Tenantid"] = tenantId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

schoolTokenAxios.interceptors.request.use(
  (config) => {
    const schoolAccessToken = localStorage.getItem("schoolToken");
    if (schoolAccessToken) {
      config.headers["Authorization"] = `Bearer ${schoolAccessToken}`;
    }
    if (tenantId) {
      config.headers["Tenantid"] = tenantId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth token refresh logic

authTokenAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const refreshToken = localStorage.getItem("authRefreshToken");
        const refreshResponse = await axios.post(
          API_ENDPOINTS.auth.refreshToken,
          {
            refreshToken,
          }
        );
        const { accessToken, refreshToken: newRefreshToken } =
          refreshResponse.data;
        // Update localStorage
        localStorage.setItem("authAccessToken", accessToken);
        localStorage.setItem("authRefreshToken", newRefreshToken);
        // Update axios default
        authTokenAxios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${accessToken}`;
        // Update the failed request
        prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return authTokenAxios(prevRequest);
      } catch (refreshError) {
        // On refresh fail, clear tokens and redirect to login
        localStorage.removeItem("authAccessToken");
        localStorage.removeItem("authRefreshToken");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

// School token refresh logic

schoolTokenAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const schoolRefreshToken = localStorage.getItem("schoolRefreshToken");
        const refreshResponse = await axios.get(
          API_ENDPOINTS.auth.schoolRefreshToken,
          {
            headers: {
              Authorization: `Bearer ${schoolRefreshToken}`,
            },
          }
        );
        const { accessToken, refreshToken: newRefreshToken } =
          refreshResponse.data.obj;
        // Update localStorage
        localStorage.setItem("schoolToken", accessToken);
        localStorage.setItem("schoolRefreshToken", newRefreshToken);
        // Update axios default
        schoolTokenAxios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${accessToken}`;
        // Update the failed request
        prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return schoolTokenAxios(prevRequest);
      } catch (refreshError) {
        // On refresh fail, clear tokens and redirect to login
        localStorage.removeItem("schoolToken");
        localStorage.removeItem("schoolRefreshToken");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);
